<div
	class="triangle"
	highlight
	type="bg"
	[isPositive]="value > 0"
	[isNegative]="value < 0"
	[class.rotated]="value < 0"
	[style.width]="triangleWidth"
	[style.height]="triangleHeight"
></div>
